import { z } from "zod";

/** Root snapshot only; full dependency and durable export jobs are separate. */
export const assistantCodegenArtifactRequestSchema = z
  .object({
    projectId: z.string().min(1).max(128),
    projectRevId: z.string().min(1).max(128),
    revision: z.number().int().positive(),
    expectedSourceSha256: z.string().regex(/^[a-f0-9]{64}$/),
    expectedContext: z.string().min(1).max(256),
    scheme: z.enum(["blackbox", "plain"]),
  })
  .strict();
export type AssistantCodegenArtifactRequest = z.infer<
  typeof assistantCodegenArtifactRequestSchema
>;
export interface AssistantCodegenArtifact {
  profile: "actor_bound_root_snapshot_v1";
  projectId: string;
  projectRevId: string;
  revision: number;
  sourceSha256: string;
  optionsSha256: string;
  metadataId: string;
  configSha256: string;
  runtimeFlagsSha256: string;
  files: {
    path: string;
    bytes: string;
    encoding: "utf8" | "base64";
    sha256: string;
    size: number;
  }[];
  manifestSha256: string;
  /** Native React runtime imports remain required; this is not hosting. */
  delivery: "inline_native_output";
}
